import { EasyVrpMapPoint } from './EasyVrpMapPoint';
import { EasyVrpMapContext } from './EasyVrpMapContext';
import { EasyVrpMapRoutesManager } from './EasyVrpMapRoutesManager';
import { EasyVrpMapJobsManager } from './EasyVrpMapJobsManager';
import { EasyVrpMapNucleiManager } from './EasyVrpMapNucleiManager';

export interface EasyVrpMapManagerFunctions {
    onNucleiDragEnd: (x: number, y: number, vehicle_id: number) => void;
}

export class EasyVrpMapManager {
    public routesManager: EasyVrpMapRoutesManager;
    public jobsManager: EasyVrpMapJobsManager;
    public nucleiManager: EasyVrpMapNucleiManager;

    _settings_display_order_on_map: boolean = true; //  getSettingsDisplayOrderOnMap
    _settings_display_nuclei_on_map: boolean = true; // getSettingsDisplayNucleiOnMap

    constructor(fn: EasyVrpMapManagerFunctions) {
        this.routesManager = new EasyVrpMapRoutesManager();
        this.jobsManager = new EasyVrpMapJobsManager();
        this.nucleiManager = new EasyVrpMapNucleiManager(fn.onNucleiDragEnd);
    }

    public drawMapElements(mc: EasyVrpMapContext) {
        if (
            typeof Targeo === 'undefined' ||
            typeof Targeo.Base === 'undefined' ||
            typeof Targeo.Base.Map === 'undefined'
        ) {
            console.warn('Targeo.Base.Map is not defined, cannot clear map elements');
            return;
        }
        let vehicleId: number | null = mc.getContext().selectedVehicleId;
        let uniqueRouteId: string | null = mc.getContext().selectedRouteId;
        Targeo.Base.Map.getObjectManager().disableRefreshing('drawMapElements');
        this.clearMapElements();
        this.routesManager.addRoutesToMap(mc, uniqueRouteId);
        this.jobsManager.addJobsToMap(mc, uniqueRouteId, this._settings_display_order_on_map);
        if (this._settings_display_nuclei_on_map) {
            this.nucleiManager.addNucleiToMap(mc, vehicleId);
        }
        this.jobsManager.zoomToBounds();
        Targeo.Base.Map.getObjectManager().enableRefreshing('drawMapElements');
    }

    public clearMapElements() {
        if (
            typeof Targeo === 'undefined' ||
            typeof Targeo.Base === 'undefined' ||
            typeof Targeo.Base.Map === 'undefined'
        ) {
            console.warn('Targeo.Base.Map is not defined, cannot clear map elements');
            return;
        }
        Targeo.Base.Map.getObjectManager().disableRefreshing('clearMapElements');
        this.routesManager.clearMap();
        this.jobsManager.clearMap();
        this.nucleiManager.clearMap();
        Targeo.Base.Map.getObjectManager().enableRefreshing('clearMapElements');
    }

    public reloadMapElements(mc: EasyVrpMapContext) {
        this.clearMapElements();
        this.drawMapElements(mc);
    }

    public getMapNuclei(): EasyVrpMapPoint[] {
        return this.nucleiManager.mapNuclei;
    }
}
